import React from "react";

const translationDe = {
    cart: {
        title: "Mein Warenkorb",
        continue: "Weiter",
        fastCheckout: "Zur Kasse gehen",
        free: "kostenlos",
        cartEmpty: "Warenkorb leer",
        emptyDisclamer:
            "Du hast noch keine Produkte in deinen Warenkorb gelegt.",
        compensation: "CO2- und Wasserausgleich",
        reusableBowlsPrice: "Mehrwegschüssel-Pfand",
        productCount_one: " ({{count}} Produkt)",
        productCount_other: " ({{count}} Produkte)",
        product: "Produkte",
        firmDiscountExcluded:
            "Der Firmenrabatt wird auf der letzten Seite abgezogen.",
        energyFee: {
            title: "Energiekostenpauschale",
            text: "Anstatt unsere Salatpreise zu erhöhen, erheben wir angesichts der dramatischen Kostensteigerungen in der Energiekrise eine kleine Pauschale von 1,50€ pro Lieferung. Ohne diese wäre es uns nicht möglich, Pottsalat in seiner jetzigen nachhaltigen Form weiter zu betreiben.\n\nSobald die Energiepreise sich normalisieren, werden wir die Pauschale wieder abschaffen. Vielen Dank für euer Verständnis!",
            close: "Hinweiß schließen",
        },
        coupons: {
            title: "Gutschein",
            redeemCode: "Gutschein einlösen",
            enterCode: "Gutscheincode eingeben",
            save: "Speichern",
            loading: "Gutscheincode wird überprüft",
            companyDiscount: "Firmenrabatt",
            errors: {
                wrong: "Der Gutscheincode ist nicht gültig.",
                required: "Bitte gib einen Gutscheincode ein.",
            },
        },
        createGroup: {
            title: "Gemeinsam bestellen",
            info: "Teile deinen Warenkorb über einen Link mit Anderen.",
            cta: "Loslegen",
        },
        cartItem: {
            kcal: "kcal",
            CO2e: "CO2e",
            water: "Wasser",
            remove: "Löschen",
            totalPrice: "Gesamt:",
        },
        summary: {
            label: "Gesamtsumme",
            subtotal: "Zwischensumme",
            greenClubMember: "% Green Club Vorteil",
            shipment: "Liefergebühr",
            freeCharge: "(kostenfrei ab {{threshold}})",
            voucher: "Gutschein",
            total: "Gesamtsumme",
            vat: "inkl. MwSt.",
        },
        cutlery: {
            label: "Besteck ",
            free: "(Kostenlos)",
            text: "Ich benötige Besteck zu meiner Bestellung.",
            takeCutlery: "Besteck hinzufügen",
            takenCutlery: "Besteck entfernen",
        },
        freeDelivery: {
            title: "Nur noch {{amount}} zur kostenlosen Lieferung.",
            text: "Füge doch ein Getränk, Brot oder Dessert hinzu.",
            CTA: "Produkte ansehen",
        },
        minimumOrderValue: {
            title: "Noch {{amount}} zum Mindestbestellwert.",
        },
        fastCheckoutPopup: {
            title: "Express Checkout",
            selectDayTitle: "Wann sollen wir liefern?",
            selectDeliveryWindow: "Lieferfenster auswählen",
            pickUpAddress: "Abholanschrift",
            payButton: "Zahlungspflichtig bestellen",
            editDetailsButton: "Details bearbeiten",
            deliveryAddress: "Lieferanschrift",
            billAdress: "Rechnungs-anschrift",
            paymentMethod: "Zahlart",
            deliveryWindow: "Lieferfenster",
            remarks: "Anmerkungen",
            changeTimeButton: "Lieferfenster ändern",
            adressAsDelivery: "Entspricht der Lieferanschrift.",
            earlyDelivery: "Lieferung ist früher möglich",
            deliveryDescription:
                "Bitte gegenüber von den Altpapiercontainern klingeln dasdasd",
            deliveryInstructionOne: "Beim Pförtner abgeben",
            deliveryInstructionTwo: "Bitte vorher klingeln",
            pickupTerms:
                "Mit dem Anklicken des Buttons Bestellen und Bezahlen erklären Sie sich mit dem Inhalt des Warenkorbs, den von Ihnen eingegebenen Daten, unseren",
            pickupTermsLinkOne: "AGB,",
            pickupTermsLinkTwo: "Datenschutz-bestimmungen",
            pickupTermsLinkThree: "Widerrufsbedingungen",
        },
        payment: {
            none: "Payment not selected",
            pottsalat_paypal: "PayPal",
            pottsalat_computop_creditcard:
                "Kreditkarte, Google Pay oder Apple Pay",
            pottsalat_computop_sofort: "Klarna",
        },
        reusableBowls: {
            title: "Mehrwegschüsseln",
            subtitle: "Lass dir das Essen in Mehrwegschüsseln zubereiten.",
            price: "Pro Schüssel berechnen wir einen Pfand von 6 € inkl. MwSt. Bei Rückgabe deiner Mehrwegschüsseln erstatten wir dir das passende Pfand zurück.",
            paymentMethod:
                "Eine Bestellung mit Mehrwegschüsseln ist nur mit PayPal zahlbar",
            return: "Aus logistischen Gründen kannst du max. 5 Mehrwegschüsseln zurückgeben",
            paymentBanner:
                "Bestellungen mit Mehrwegschüsseln sind derzeit nur mit PayPal zahlbar.",
            link: "Weitere Infos ansehen",
            notAvailable:
                "Unsere Mehrwegschüsseln sind bald wieder verfügbar. Die Nachfrage danach ist zurzeit sehr groß.",
        },
    },

    form: {
        label: {
            email: "E-Mail Adresse",
            repeatEmail: "E-Mail Adresse wiederholen",
            password: "Passwort",
            newPassword: "Neues Passwort",
            repeatPassword: "Neues Passwort wiederholen",
            changePassword: "Passwort ändern",
            firstName: "Vorname",
            companyOrPerson: "Ich bestelle als",
            company: "Unternehmen",
            legalForm: "Rechtsform",
            person: "Privatperson",
            lastName: "Nachname",
            companyName: "Firmenname",
            address: "Straße und Hausnr.",
            postcode: "Postleitzahl",
            city: "Ort",
            phone: "Telefonnummer",
            repeatPhone: "Telefonnummer wiederholen",
            save: "Speichern",
            optional: " (optional)",
            pleaseSelect: "Bitte auswählen",
            AGBs: {
                firstPart:
                    "Mit der Erstellung eines Benutzerkontos akzeptiere ich die ",
                linkPart: "allgemeinen Geschäftsbedingungen (AGB) ",
                linkClip: "und die ",
                linkPartPrivacy: "Datenschutzerklärung ",
                lastPart: "für die Nutzung des Pottsalat Angebotes.",
            },
        },
        errors: {
            containsNonPrintables: "Enthält unzulässige Zeichen",
            email: "Bitte gib eine richtige E-Mail Adresse an.",
            required: "Pflichtfeld bitte ausfüllen.",
            short: "Das Passwort sollte mindestens zwölf Zeichen lang sein.",
            mustMatch: {
                password: "Bitte gib zwei identische Passwörter ein.",
                email: "Bitte gib zwei identische E-Mail Adressen an.",
                phone: "Bitte gib zwei identische Telefonnummern an.",
            },
            notStrong:
                "Dein Passwort entspricht nicht unseren Passwort-Anforderungen",
        },
        password: {
            show: "Anzeigen",
            hide: "Verstecken",
            strongPassword: {
                title: "Anforderungen ans Passwort",
                isLong: "Mindestens 8 Zeichen",
                containsNumber: "Enthält eine Nummer",
                variesInCase: "Mindestens ein Buchstabe ist großgeschrieben",
                hasSpecialChars: "Enthält ein Sonderzeichen",
            },
        },
    },

    joinGroupOrder: {
        subTitle: "EINLADUNG ZUR GRUPPENBESTELLUNG",
        title: "Bestelle gemeinsam mit {{name}} bei Pottsalat. 🚀",
        description:
            "{{name}} hat dich zur Gruppenbestellung bei Pottsalat eingeladen. Verrate uns deinen Vornamen und tritt der Bestellung bei.",
        finishTill: "Bestellung abschließen bis {{till}} Uhr.",
        payedBy:
            "Die Bestellung wird von {{name}} bezahlt und bis spätestens {{till}} Uhr getätigt.",
        joinOrder: "Beitreten",
        declineOrder: "Nicht beitreten",
        inputName: "Dein Vorname",
        delivery: "Lieferung",
        pickup: "Abholung",
        location: "📍",
        time: "⏱️",
        creditCard: "💳",
        buttonJoinGroup: "Beitreten",
        buttonDeclineGroup: "Nicht beitreten",
    },

    memberGroupOrder: {
        bannerText: "Bestellung von {{name}}",
        bannerTimeText: "Produkte hinzufügen bis",
        subTitle: "Du fügst Produkte zur Gruppenbestellung hinzu.",
        emptyDisclaimer:
            "Gehe nun einfach ins Menü und füge deine Produkte der Gruppenbestellung hinzu",
        title: "Warenkorb",
        cancelGroupOrder: {
            title: "Du möchtest lieber eine eigene Bestellung tätigen?",
            subTitle: "Dann verlasse einfach die Gruppenbestellung.",
        },
        cancelGroupOrderPopup: {
            title: "Wirklich verlassen?",
            description:
                "Deine Produkte werden nicht zum gemeinsamen Warenkorb hinzugefügt.",
            acceptButton: "Gruppenbestellung verlassen",
            cancelButton: "Abbrechen",
        },
        cancelButton: "Verlassen",
        checkoutBanner:
            "Gutscheine können nur vom Gastgeber der Gruppenbestellung eingelöst werden.",
        commitOrderButton: "Zur Bestellung hinzufügen",
        productCount_one: " {{count}} Produkt",
        productCount_other: " {{count}} Produkte",
    },

    ownerGroupOrder: {
        bannerText: "Laufende Gruppenbestellung",
        bannerTimeText: "Bestellung abschließen bis",
    },

    legalFormTypes: {
        AG: "AG",
        "e.K.": "e.K.",
        Einzelunternehmen: "Einzelunternehmen",
        GbR: "GbR",
        GmbH: "GmbH",
        OHG: "OHG",
        "e.V.": "e.V.",
        "e.G.": "e.G.",
        UG: "UG",
        "GmbH&Co. KG.": "GmbH&Co. KG.",
    },

    login: {
        title: "Melde dich an",
        forgotPassword: "Passwort vergessen?",
        forgotPasswordInfo:
            "Gib die E-Mail-Adresse ein, mit der du dein Pottsalat Konto erstellt hast. So können wir dir einen Link zum Zurücksetzen schicken.",
        toLogin: "Zurück zur Anmeldung",
        staySigned: "Angemeldet bleiben",
        submit: "Anmelden",
        resetPassword: "Absenden",
        newCustomer: {
            title: "Neu bei Pottsalat?",
            text: "Erstelle dir ein Benutzerkonto, um Pottsalat Rechnungen herunterzuladen, alte Bestellungen mit einem Klick erneut zu bestellen und schneller zum Bestellabschluss zu kommen. Oder bestelle eben als Gast.",
            register: "Benutzerkonto erstellen",
            continueGuest: "Weiter als Gast",
        },
    },

    resetPassword: {
        info: "Hier kannst Du dein Passwort neu setzen.",
        invalidLink:
            "Der Link war leider nicht korrekt. Bitte versuche es noch einmal.",
    },

    register: {
        title: "Benutzerkonto erstellen",
        submit: "Jetzt registrieren",
        success: {
            title: "Pottsalat-Konto erstellt!",
            text: "Bitte bestätige dein neues Benutzerkonto mit Klick auf den Link, den wir dir in einer E-Mail geschickt haben.",
            continue: "Bestellung fortsetzen",
        },
    },

    emptyCart: {
        label: "Lege Produkte in den Warenkorb und füge sie zu deiner laufenden Bestellung hinzu.",
        openButton: "Produkte ansehen",
    },

    addToOrderPopup: {
        title: "Produkte zur laufenden Bestellung hinzufügen?",
        subtitle:
            "Du hast momentan eine laufende Bestellung. Wenn du magst würden wir dir gerne deine Produkte aus dem Warenkorb zur laufenden Bestellung hinzufügen.",
        addButton: "Zur Bestellung hinzufügen",
        cancelButton: "Neue Bestellung aufgeben",
        order: {
            title: "Laufende Bestellung",
            date: "Bestelldatum",
            delivery: "Lieferung",
        },
    },

    addToOrderDropdown: {
        addToOrderTitle: "Zur laufenden Bestellung hinzufügen",
        placeNewOrderTitle: "Neue Bestellung",
        placeNewOrderDescription: "Zeitpunkt wählst du später aus",
    },

    tooManyProductsPopup: {
        title: "Für Nachbestellung Produkte entfernen.",
        description:
            "Du hast zu viele Produkte im Warenkorb um sie zur laufenden Bestellung hinzuzufügen. Maximal vier Salate / Bowls und insgesamt zehn Produkte sind möglich.",
        closeButton: "Hinweiß schließen",
    },

    orderSummaryPopup: {
        title: "Liefernummer",
        subtitle: "Bestellübersicht",
        body: {
            deliveryDate: "Bestelldatum",
            timeWindow: "Zeitfenster",
        },
        confirmButton: "Schließen",
    },

    paymentSelect: {
        heading: "Wie möchtest du bezahlen?",
        paypalHeading: "Paypal",
        paypalText: "Paypal-Konto notwendig.",
        creditCardHeading: "Kreditkarte, Google Pay & Apple Pay",
        creditCardText: "",
        klarnaHeading: "Online-Banking mit Klarna Sofort",
        klarnaText: "Kein Klarna-Konto notwendig.",
        payDirektHeading: "Online-Banking mit Paydirekt",
        payDirektText: "Kein Paydirekt-Konto notwendig.",
        monduInvoiceHeading: "Auf Rechnung (für Unternehmen)",
        monduInvoiceText:
            "Jetzt kaufen, in 30 Tagen bezahlen! Hinweise zur Verarbeitung Ihrer personenbezogenen Daten durch die Mondu GmbH finden Sie ",
        monduDirectDebitHeading: "SEPA Lastschrift (für Unternehmen)",
        monduDirectDebitText:
            "Komfortabler Bankeinzug ohne Überweisen! Hinweise zur Verarbeitung Ihrer personenbezogenen Daten durch die Mondu GmbH finden Sie ",
        monduAppendLinkText: "hier",
        paymentError: {
            headline: "Es ist ein Fehler aufgetreten.",
            content: "Bitte wähle deine Zahlungsmethode erneut aus.",
        },
    },

    loader: {
        pageIsLoading: "Die Seite wird gerade geladen",
    },

    toasts: {
        redo: "Rückgängig machen",
        cartOutOfStock:
            "Dein Warenkorb hat sich aufgrund deines Standort-Wechsels an die aktuellen Bestände im ausgewählten Store angepasst.",
        add_product: {
            title_success: "{{name}} wurde zum Warenkorb hinzugefügt.",
            title_error:
                "{{name}} konnte nicht zum Warenkorb hinzugefügt werden.",
        },
        remove_product: {
            title_success: "{{name}} wurde vom Warenkorb entfernt.",
            title_error:
                "{{name}} konnte nicht zum Warenkorb hinzugefügt werden.",
        },
        update_quantity: {
            title_success:
                "Die Anzahl von {{name}} wurde von {{prevQ}} auf {{currentQ}} angepasst.",
            title_error:
                "Die Anzahl von {{name}} konnte nicht geändert werden.",
        },
        remove_coupon: {
            title_success: "Der Gutschein wurde entfernt.",
            title_error: "Der Gutschein konnte nicht entfernt werden.",
        },
        add_coupon: {
            title: "Der Gutscheincode {{code}} wurde hinzugefügt.",
        },
        login: {
            success: "Du hast dich erfolgreich als {{name}} angemeldet.",
            error: "E-Mail Adresse oder Passwort falsch. Bitte versuche es erneut.",
        },
        userDetails: {
            success:
                "Du hast die Kontaktinformationen erfolgreich hinzugefügt!",
            error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
        },
        register: {
            error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
        },
        passwordReset: {
            success: "Du hast dein Passwort erfolgreich zurückgesetzt",
            error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
        },
        locationUpdate: {
            error: "Fehler beim Aktualisieren des Standorts. Bitte versuche es erneut.",
        },
        timeslots: {
            error: "Dieses Lieferfenster ist bereits ausgebucht.",
        },
    },

    popup: {
        close: "Abbrechen",
    },

    storeHint: {
        open: "Filiale geöffnet",
        close: {
            title: "Filiale geschlossen",
            subtitle: "Einfach vorbestellen",
        },
        openingSoon: {
            title: "Filiale öffnet bald",
            subtitle: "Einfach vorbestellen",
        },
        popupClosed: {
            title: "Filiale aktuell geschlossen",
            subtitle: "Vorbestellungen jetzt möglich",
            content:
                "Unser Filiale ist aktuell geschlossen. Du kannst jetzt jedoch bereits vorbestellen.",
        },
        popupOpeningSoon: {
            title: "Filiale öffnet bald",
            subtitle: "Vorbestellungen jetzt möglich",
            content:
                "Unser Filiale ist aktuell geschlossen, öffnet aber bald. Du kannst jetzt bereits vorbestellen.",
        },
    },

    delivery: {
        in: "in",
        to: "nach",
        pickup: "Abholung",
        delivery: "Lieferung",
    },

    traffic: {
        notAvailable: "Nicht mehr verfügbar",
    },

    env_compensation: {
        title: "Umweltauswirkung",
        info: {
            cta: "Was tun wir?",
            title: "klimafreundliche Landwirtschaft",
            text: "Für deine Bestellung wird CO2 freigesetzt und Wasser verbraucht. Mit deiner Ausgleichszahlung förderst du klimafreundliche Landwirtschaft in Deutschland mit uns. Durch regenerative Methoden kann die Landwirtschaft CO₂ aus der Atmosphäre im Boden speichern und gleichzeitig Biodiversität fördern und Erträge sichern.",
            textBeforeLink:
                "Alle Details zu unserem Klimaschutzprojekt findest du ",
            link: "https://pottsalat.de/impact-report-nrw/",
            linkText: "hier",
            button: "Info schließen",
        },
        summary: "Deine Bestellung verursacht",
        options: {
            single: "CO2 & Wasserverbrauch ausgleichen",
            double: "Klimaschutzprojekte doppelt fördern",
            none: "Keine Ausgleichszahlung",
            price: "{{price}} (inkl. {{tax}} MwSt.)",
        },
    },

    userDetails: {
        contact: {
            title: "Wie können wir dich erreichen?",
            subtitle:
                "Damit wir dir die Rechnung zusenden und dich notfalls für die Bestellung erreichen können.",
        },
        title: "Vervollständige deine Daten",
        subtitle:
            "Anmerkungen zu deiner Bestellung kannst du auf der letzten Seite verfassen.",
        billingAddress: "Rechnungsadresse",
        sameAsBilling: "Lieferadresse entspricht Rechnungsadresse",
        pickup: {
            title: "Rechnungsanschrift",
            subtitle:
                "Anmerkungen zu deiner Bestellung kannst du später auf der letzten Seite verfassen.",
        },
    },

    timeSlotSelect: {
        timeSlotsTaken: {
            heading: "Sorry wir sind für heute ausverkauft.",
            content:
                "Ein anderer Kunde war leider schneller und hat dir jetzt gerade das letzte Lieferfenster für heute weggeschnappt. Es tut uns sehr leid, aber wir können leider nicht mehr zu dir liefern.",
        },
        slotFullDelivery: {
            heading: "Sorry wir sind für heute ausverkauft.",
            content:
                "Ein anderer Kunde war leider schneller und hat dir jetzt gerade das letzte Lieferfenster für heute weggeschnappt. Es tut uns sehr leid, aber wir können leider nicht mehr zu dir liefern.",
        },
        slotFullPickup: {
            heading: "Sorry wir sind für heute ausverkauft.",
            content:
                "Ein anderer Kunde war leider schneller und hat dir jetzt gerade das letzte Abholfenster für heute weggeschnappt. Wähle bitte einen anderen Tag aus.",
        },
        slotTimeoutDelivery: {
            heading: "Sorry wir sind für heute ausverkauft.",
            content:
                "Ein anderer Kunde war leider schneller und hat dir jetzt gerade das letzte Lieferfenster für heute weggeschnappt. Es tut uns sehr leid, aber wir können leider nicht mehr zu dir liefern.",
        },
        slotTimeoutPickup: {
            heading: "Sorry wir sind für heute ausverkauft.",
            content:
                "Ein anderer Kunde war leider schneller und hat dir jetzt gerade das letzte Abholfenster für heute weggeschnappt. Wähle bitte einen anderen Tag aus.",
        },
        noSlotsToday: {
            heading: "Sorry, wir haben heute geschlossen.",
            content:
                "Für heute kannst du leider nichts bestellen. Daher bestelle doch einfach für einen der nächsten Tage vor.",
        },
        storeClosed: {
            heading: "Sorry, wir haben heute geschlossen.",
            content:
                "Für heute kannst du leider nichts bestellen. Daher bestelle doch einfach für einen der nächsten Tage vor.",
        },
        header: {
            delivery: "Wann sollen wir liefern?",
            pickup: "Wann möchtest du abholen?",
        },
        deliveryTitle: "Lieferfenster auswählen",
        pickupTitle: "Abholfenster auswählen",
        earliestPickup: "Frühstmögliche Abholung",
        earliestDelivery: "Frühstmögliche Lieferung",
        firstAvailableDelivery: "Der frühste Liefer- oder Abholzeitpunkt ",
        firstAvailableDeliveryOpeningSoon: "Frühstmöglicher Lieferzeitpunkt",
        firstAvailablePickupOpeningSoon: "Frühstmöglicher Abholzeitpunkt",
        continue: "Weiter",
        editSelection: "Uhrzeit ändern",
        earyDeliveryConfirmed: "Lieferung ist früher möglich",
        earlyOnSite: {
            title: "Bist du früher vor Ort?",
            yes: "Ja, ich bin vor Ort. Es kann auch früher geliefert werden.",
            no: "Nein, bitte nicht früher liefern.",
            finished: "Fertig",
            info: {
                title: "“Früher vor Ort” kurz erklärt",
                contentOne:
                    "Wenn du hier auf “Ja, ich bin vor Ort” klickst, kann es sein, dass wir schon vor deinem ausgewählten Lieferfenster bei dir sind, falls unser Fahrer wegen einer anderen Bestellung früher in deiner Nähe ist.",
                contentTwo:
                    "Wir können Dir dies zwar nicht versprechen. Aber wir geben unser Bestes.",
                close: "Hinweis schließen",
            },
        },
        info: {
            title: "Die Zeitfenster kurz erklärt",
            subtitle:
                "Damit du deine Bestellung pünktlich erhältst und nicht lange warten musst, begrenzen wir die Anzahl an möglichen Bestellungen zu den genannten Zeiträumen.",
            ok: "Du kannst in Ruhe bestellen.",
            warning: "Einige Bestellungen können wir noch annehmen.",
            critical: "Nur noch sehr wenige Bestellungen möglich.",
            close: "Info schließen",
        },
    },

    days: {
        today: "Heute",
        tomorrow: "Morgen",
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag",
    },

    overview: {
        title: "Bestellung überprüfen",
        products: "Produkte ({{quantity}})",
        productsNoCount: "Produkte",
        orderType: "Art der Bestellung",
        payment: "Zahlungsart",
        billing: "Rechnungsanschrift",
        delivery: "Lieferanschrift",
        timeslot: "Lieferfenster",
        pickup: "Zeitpunkt",
        deliveryInstructions: {
            title: "Lieferhinweise",
            noDoorbell: "Bitte nicht klingeln",
            deliveryPhoneCall: "Anrufen, wenn Fahrer:in da ist",
            givePorter: "Beim Pförtner abgeben",
            contactlessDelivery: "Kontaktlose Lieferung",
        },
        comment: "Anmerkungen zu deiner Lieferung",
        commentTitle: "Anmerkungen",
        commentPlaceholder:
            "Wegbeschreibung, Gebäude-Nr. oder andere Hinweise...",
        commentPickupPlaceholder:
            "Sollen wir noch was bei deiner Bestellung beachten?",
        edit: "Ändern",
        acceptTerms:
            "Bitte akzeptiere unsere Allgemeinen Geschäftsbedingungen und Widerrufsbestimmungen.",
        terms: {
            firstPart: "Mit deiner Bestellung erklärst du dich mit unserer ",
            linkPartAGB: "AGB",
            linkClip1: ", den ",
            linkPartPrivacy: "Datenschutz\u00ADbestimmungen",
            linkClip2: " und den ",
            linkPartCancellation: "Widerrufsbedingungen",
            lastPart: " einverstanden.",
        },
        next: "Zahlungspflichtig bestellen",
        timeslotEdit: {
            deliveryHeader: "Lieferfenster auswählen",
            pickupHeader: "Zeitfenster auswählen",
            nextDeliveryTime: "Der nächste Lieferzeitpunkt",
            nextPickupTime: "Der nächste Abholzeitpunkt",
            backToTimeSelect: "Ich möchte eine andere Uhrzeit auswählen",
            notification: {
                deliveryTitle: "Dieses Lieferfenster ist bereits ausgebucht.",
                pickupTitle: "Dieses Zeitfenster ist bereits ausgebucht",
                content:
                    "Wir haben leider zum gleichen Zeitpunkt zu viele Bestellungen erhalten. Wähle bitte neu aus.",
            },
        },
    },

    ingredientCategories: {
        fruit: {
            name: "Obst",
            description: "Ananas, Himbeeren, Melone...",
        },
        chinese: {
            name: "Chinesisch",
            description: "Burrata, Tabouleh, Teriyaki Sauce...",
        },
        dressings: {
            name: "Dressings",
            description: "Caesar, Honig-Senf, Joghurt...",
        },
        sauces: {
            name: "Saucen",
            description: "Teriyaki, Erdnuss, Waikiki...",
        },
        meat: {
            name: "Fleisch & Fisch",
            description: "Hähnchenbrust, Garnelen...",
        },
        vegetables: {
            name: "Gemüse",
            description: "Gurke, Möhren, Rotkohl...",
        },
        italian: {
            name: "Italienisch",
            description: "Basilikum, Parmesan, Tomate...",
        },
        cheese: {
            name: "Käse",
            description: "Frischkäse, Mozzarella, Ziegenkäse...",
        },
        oriental: {
            name: "Orientalisch",
            description: "Basilikum, Parmesan, Tomate...",
        },
        "geringer-co2-ausstoss": {
            name: (
                <div data-name="geringer-co2-ausstoss">
                    Geringer CO<sub>2</sub>-Ausstoß
                </div>
            ),
            description: "",
        },
        "weniger-als-30-kalorien": {
            name: "Weniger als 30 kcal",
            description: "",
        },
    },

    header: {
        back: "Zurück",
        menu: "Menü",
        abort: "Abbrechen",
        potti: "Dein Salat",
        bowl: "Deine Bowl",
        ramen: "Deine Ramen",
        toUser: "Zum Benutzerkonto",
        lowerMenu: {
            salads: "Salate",
            bowls: "Bowls",
            soup: "Ramen",
            dips: "Brote & Dips",
            desserts: "Desserts",
            beverages: "Getränke",
        },
        avatar: {
            loggedOut: "Anmelden",
            loggedIn: "Mein Konto",
        },
    },

    footer: {
        imprint: "Impressum",
        dataProtection: "Datenschutz",
        terms: "AGB",
        allergens: "Allergen-Liste",
        press: "Presse",
        jobs: "Jobs",
        withdrawal: "Widerrufsbelehrung",
        cookies: "Cookie Erklärung",
        investors: "Vermögensanlagen Informationsblatt",
    },

    newFooter: {
        franchise: {
            topHeading: "Pottsalat Franchise",
            bottomHeading: "Eröffne Pottsalat in deiner Stadt",
            button: "Franchise-Partner werden",
        },
        socialMediaText:
            "Wir sind Pottsalat der gesunde und klimafreundliche Lieferservice. Wir liefern pünktlich im ausgewählten Zeitfenster zu Dir.",
        storesTitle: "Standorte",
        deliveryAreasTitle: "Wir liefern nach",
    },

    desktopFooter: {
        firstEntry: {
            heading: "Täglich frisch",
            content:
                "Wir beziehen jeden Tag neues Obst & Gemüse und bereiten jeden Salat frisch für Dich zu.",
        },
        secondEntry: {
            heading: "Gesund & Lecker",
            content:
                "Unsere Salate schmecken lecker, machen satt und sind definitiv gesünder als jede Currywurst...",
        },
        thirdEntry: {
            heading: "Ökologisch",
            content:
                "Alle Salate liefern wir ausschließlich in ökologischen und recyclebaren Verpackungen.",
        },
        fourthEntry: {
            heading: "Lokal",
            content:
                "Wir liefern mit dem Rad in ca. 20-40 Minuten im Essener Stadtgebiet. Das spart nicht nur Zeit, sondern ist auch gut für die Umwelt.",
        },
    },

    complementary: {
        drinks: "Darf es noch ein Getränk sein?",
        desserts: "Darf es noch ein Dessert sein?",
        other: "Darf es noch etwas anderes sein?",
        similarProducts: "Ähnliche Produkte",
        seeProduct: "Produkt ansehen",
        addToCart: "In den Warenkorb",
        ingredients: "Zutaten",
        kcal: "kcal",
    },

    ongoingOrder: {
        info: "Du hast nicht mehr viel Zeit um etwas zur laufenden Bestellung hinzuzufügen.",
        title: "Laufende Bestellung",
        openButton: "Ansehen",
    },

    countDown: {
        info: "Du hast nicht mehr viel Zeit um etwas zur laufenden Bestellung hinzuzufügen.",
    },

    categoryItems: {
        vegan: "Vegan",
        vegetarian: "Vegetarisch",
        glutenFree: "Glutenfrei",
        sugarFree: "Zuckerarm",
        lowCarbs: "Low Carb",
        klima: "Klimafreundlich",
        // This are needed for filters to have dynamic content
        glutenfrei: "Glutenfrei",
        "weniger-als-30-kalorien": "Low Carb",
        vegetarisch: "Vegetarisch",
        klimafreundlich: "Klimafreundlich",
    },

    addressOverlay: {
        noHousenumber: "Bitte gib noch eine Hausnummer ein",
        seeLocations: "Unsere Liefergebiete ansehen",
        saveLocation: "Bestätigen",
        iWantToPickup: "Ich möchte selbst abholen",
        onlyPickupPossible: "Nur Selbstabholung möglich",
        pickupQuestion: "Wo möchtest Du die Bestellung abholen?",
        pickup: "Abholung:",
        delivery: "Lieferung nach:",
        invalidPostcode: {
            title: "Eventuell liefern wir bald zu dir",
            text: "Sobald wir in Deinem Liefergebiet sind, können wir Dich gern benachrichtigen.",
            CTA: "Benachrichtige mich",
        },
    },

    productDetails: {
        productDetailNotice: "Fördert klimafreundliche Landwirtschaft",
        thereIsMore: "+ weitere Zutaten",
        seeIngredients: { top: "Zutaten hinzu-", bottom: "oder abwählen" },
        outOfStock: "Dieses Produkt ist ausverkauft.",
        availableSoon: "Bald wieder verfügbar",
        notifications: {
            addToCart:
                "<strong>{{productName}}</strong> zum Warenkorb hinzugefügt.",
            goToCart: "Zum Warenkorb",
            continueShopping: "Weiter einkaufen",
            productModified:
                "Wir verrechnen die entfernte Zutat mit Extras, die hinzugefügt werden.",
        },
        alert: {
            close: "Hinweis schließen",
            basketError: {
                title: "Fehler",
                text: "Hier ist leider etwas schiefgelaufen. Bitte probiere es noch einmal.",
            },
            salat: {
                removeBase: {
                    title: "Die Salat-Basis kannst du nicht entfernen.",
                    text: "Stelle dir stattdessen deinen eigenen Salat zusammen, wo du die Basis frei wählen kannst.",
                },
                removeMultipleBasic: {
                    title: "Mehr als eine Zutat kannst du nicht entfernen.",
                    text: "Stelle dir stattdessen deinen eigenen Salat zusammen, wo du die Zutaten frei wählen kannst.",
                },
                maxExtra: {
                    title: "Mehr als drei Zutaten kannst du nicht hinzufügen",
                    text: "Stelle dir stattdessen deinen eigenen Salat zusammen, wo du die Zutaten frei wählen kannst. ",
                },
                outOfStock: {
                    title: "Salat ist ausverkauft",
                    text: "Du kannst den Salat momentan nicht in den Warenkorb hinzufügen.",
                },
                goToConfigurator: "Eigenen Salat zusammenstellen",
            },
            bowl: {
                removeBase: {
                    title: "Die Bowl-Basis kannst du nicht entfernen.",
                    text: "Stelle dir stattdessen deine eigene Bowl zusammen, wo du die Basis frei wählen kannst.",
                },
                removeMultipleBasic: {
                    title: "Mehr als eine Zutat kannst du nicht entfernen.",
                    text: "Stelle dir stattdessen deinen eigenen Salat zusammen, wo du die Zutaten frei wählen kannst.",
                },
                maxExtra: {
                    title: "Mehr als drei Zutaten kannst du nicht hinzufügen.",
                    text: "Stelle dir stattdessen deine eigene Bowl zusammen, wo du die Zutaten frei wählen kannst.",
                },
                outOfStock: {
                    title: "Bowl ist ausverkauft",
                    text: "Du kannst die Bowl momentan nicht in den Warenkorb hinzufügen.",
                },
                goToConfigurator: "Eigene Bowl zusammenstellen",
            },
            suppe: {
                removeBase: {
                    title: "Die Ramen/Pho-Basis kannst du nicht entfernen.",
                    text: "Stelle dir stattdessen deine eigene Ramen zusammen, wo du die Basis frei wählen kannst.",
                },
                removeMultipleBasic: {
                    title: "Mehr als eine Zutat kannst du nicht entfernen.",
                    text: "Stelle dir stattdessen deine eigene Ramen zusammen, wo du die Zutaten frei wählen kannst.",
                },
                maxExtra: {
                    title: "Mehr als drei Zutaten kannst du nicht hinzufügen.",
                    text: "Stelle dir stattdessen deine eigene Ramen zusammen, wo du die Zutaten frei wählen kannst.",
                },
                outOfStock: {
                    title: "Ramen/Pho-Bowl ist ausverkauft",
                    text: "Du kannst die Ramen/Pho-Bowl momentan nicht in den Warenkorb hinzufügen.",
                },
                goToConfigurator: "Eigene Ramen zusammenstellen",
            },
            other: {
                outOfStock: {
                    title: "Dieses Produkt ist ausverkauft.",
                    text: "Du kannst es momentan nicht zum Warenkorb hinzufügen.",
                },
                noDressingsError: {
                    title: "Möchtest du wirklich ohne Dressing weiter?",
                    text: "Wir haben viele leckere Dressings, die super zu deinem Salat passen würden.",
                    wantDressing: "Dressing hinzufügen",
                    noDressingWanted: "Ohne Dressing weiter",
                },
            },
        },
        vegan: {
            heading: "Klassisch oder Vegan",
            type: {
                vegan: "Vegan",
                classic: "Klassisch",
            },
            overlay: {
                classic: "Wir bereiten deine vegane Alternative vor...",
                vegan: "Wir bereiten die klassische Variante vor…",
            },
            inlineNotification: {
                salad: {
                    heading: "Jetzt als vegane Option!",
                    content:
                        "Diesen Salat gibt’s jetzt auch als vegane Alternative.",
                },
                bowl: {
                    heading: "Jetzt als vegane Option!",
                    content:
                        "Diese Bowl gibt's jetzt auch als vegane Alternative.",
                },
            },
        },
        greenClub: {
            normalPriceLabel: "Normalpreis",
            greenClubPriceLabel: "Green Club Preis",
            tag: "% Green Club Vorteilspreis",
            normalPrice: "Normalpreis",
            onboardingPopup: {
                header: "Alle Bowls und Salate zum Vorteilspreis im Pottsalat Green Club",
                content:
                    "Sichere dir unsere Bowls und Salate zu günstigeren Preisen – und zwar dauerhaft. Du zahlst nur die Kosten, die für deinen Salat oder deine Bowl entstehen!",
                cta: "Kostenlos testen",
                close: "Hinweis schließen",
            },
            greenClubPriceInformation: {
                header: "Komm in den Pottsalat Green Club.",
                optionOne: "Erhalte alle Salate und Bowls zum Vorteilspreis",
                optionTwo: "Kostenlose Pottsalat Mehrweg Schüssel",
                footer: "Alle Vorteile des Pottsalat Green Clubs",
            },
            capacityPopup: {
                header: "Jetzt geht es mit den normalen Preisen weiter.",
                content:
                    "Dein Green Club Kontingent ist für heute leider erschöpft.",
                cta: "Hinweis schließen",
            },
            succesPopup: {
                text: "<strong>{{discounted}} Produkt(e) wurden zum Vorteilspreis</strong> und <strong>{{nonDiscounted}} Produkt(e) zum Normalpreis</strong> in den Warenkorb gelegt.",
            },
        },
    },

    productInfo: {
        taxRate: "inkl. {{rate}}% MwSt.",
        description: "Beschreibung",
        seeIngredients: "Zutaten ansehen",
        addToCart: "In den Warenkorb",
    },

    sauces: {
        chooseSauce: "Sauce wählen",
        title: "Sauce",
        choose: "Sauce ändern",
        noSauce: "Du hast kein Sauce ausgewählt.",
        firstSauceFree: "1x Sauce kostenlos",
        footer: {
            noSauce: "Kein Sauce ausgewählt",
            multipleSauces: "{{count}} Sauces ausgewählt",
        },
    },

    dressings: {
        chooseDressing: "Dressing wählen",
        title: "Dressing",
        choose: "Dressing ändern",
        noDressing: "Du hast kein Dressing ausgewählt.",
        firstDressingFree: "1x Dressing kostenlos",
        footer: {
            noDressing: "Kein Dressing ausgewählt",
            multipleDressings: "{{count}} Dressings ausgewählt",
        },
    },

    nutrients: {
        mobile: {
            title: "Nährwerte & Kalorien",
            withoutDressing: "Diese Angaben enthalten nicht das Dressing.",
            open: "Nährwerte ansehen",
            close: "Hinweis schließen",
            text: "Sieh dir an wie viel Energie in unserem Salat steckt.",
        },
        title: "Nährwerte",
        currentProduct: {
            title: "Angaben zum {{productName}}",
        },
        dressings: {
            title: "Angaben zu den Dressings",
        },
        sauces: {
            title: "Angaben zu den Saucen",
        },
        names: {
            carbohydrate: "Kohlenhydrate",
            fat: "Fett",
            polyunsaturatedFattyAcid: "Gesättigte Fettsäuren",
            protein: "Eiweiß",
            sugar: "Zucker",
            caloricValue: "Brennwert",
        },
    },

    basicIngredients: {
        title: "Aktuelle Zutaten",
        quantityTitle: "Aktuelle Zutaten ({{quantity}})",
        dressingsTitle: "Ausgewählte Dressings ({{quantity}})",
        overview: "Übersicht der Zutaten",
        extras: "Weitere Zutaten hinzufügen",
        extrasMobile: "Extras wählen",
        includesOne: "1x {{productName}} enthalten",
        inBowl: "in der Bowl",
        inSalad: "im Salat",
        inSoup: "in dem Ramen/Pho",
        addition: {
            title: "Zutaten hinzufügen?",
            text: "Wähle aus über <strong>60 Zutaten</strong> aus und verfeinere deinen Salat.",
        },
    },

    extraIngredients: {
        title: "Alle Zutaten {{quantity}}",
        ingredientsFor: "Zutaten anpassen für",
        selected: "{{count}} ausgewählt",
        selectedOverview: "Hinzugefügte Extras ({{count}})",
        searchPlaceholder: "Gib z.B. Käse oder Dressing ein",
        close: "Abbrechen",
    },

    customerArea: {
        nav: {
            password: "Passwort ändern",
            profile: "Profil bearbeiten",
            greenClubMember: "Green Club Mitgliedschaft",
            ordersOverview: "Bestellübersicht",
            orderDetail: "Details der Bestellung",
            address: "Adressen",
            payment: "Zahlungsart",
            logout: "Abmelden",
            abort: "Abbrechen",
        },
        register: {
            dangerTitle: "Etwas ist schief gelaufen.",
            dangerDescription:
                "Etwas ist schief gelaufen. Bitte versuche es erneut.",
        },
        login: {
            dangerTitle: "E-Mail Adresse oder Passwort falsch",
            dangerDescription:
                "E-Mail Adresse oder Passwort falsch. Bitte versuche es erneut.",
        },
        profile: {
            successTitle: "Persönliche Daten geändert.",
            successDescription: "",
        },
        password: {
            successTitle: "Passwort geändert.",
            successDescription:
                "Melde dich bitte beim nächsten Mal mit deinem neuen Passwort an.",
            dangerTitle: "Die eingegebenen Passwörter stimmen nicht überein",
            dangerDescription: "Bitte gib das Password zwei Mal ein",
        },
        ordersOverview: {
            viewOrder: "Bestellung ansehen",
            downloadReceipt: "Rechnung herunterladen",
            invoiceAvailableSoon:
                "Deine Rechnung ist noch in Arbeit, du kannst sie in Kürze hier herunterladen.",
        },
        ongoingOrder: {
            title: "Deine anstehende Bestellung",
        },
        // TODO: move this to resetPassword above
        setPassword: {
            successTitle: "Passwort geändert",
            successDescription:
                "Du kannst Dich nun mit dem neuen Passwort anmelden.",
            dangerTitle: "Passwort-Aktualisierung fehlgeschlagen",
            dangerDescription:
                "Bitte achte darauf, dass ein sicheres Passwort verwendet wurde. Achte auch darauf, dass der Link aus der Mail korrekt kopiert wurde.",
        },
    },

    chat: {
        chat: "Chat",
    },

    orderConfirmation: {
        submitFailed: "Auftragsübermittlung fehlgeschlagen",
        headline: "Vielen Dank für deine Bestellung",
        notice: "Du erhältst innerhalb von 48 Std. automatisch eine Rechnung als PDF an die von dir angegebene E-Mail Adresse von uns.",
        deliveryMessage: {
            text: "Wir haben deine Bestellung erfolgreich erhalten und liefern dir das Essen ",
            between: " zwischen ",
            orderNumber: "Liefernummer: ",
        },
        pickupMessage: {
            text: "Wir haben deine Bestellung erhalten. Du kannst dir deine Bestellung ",
            between: " zwischen ",
            at: " abholen - ",
            dortmund: "Rheinlanddamm 8, 44139 Dortmund",
            essen: "Bismarckstraße 5, 45128 Essen",
            duesseldorf: "Elisabethstraße 40217 Düsseldorf",
            duisburg: "Ruhrorter Str. 24A, 47059 Duisburg",
            koln: "Luxemburger Str. 181-183, 50939 Köln",
            mainz: "Rhein Str. 43-45, 55116 Mainz",
            bochum: "Kortumstraße 27, 44787 Bochum",
            munster: "Friedrich-Ebert-Str. 151, 48153 Münster",
            orderNumber: "Abholnummer: ",
            orderListingNumber: "Bestellnummer",
        },
        contactInfo: {
            heading:
                "Hast du etwas falsches bestellt oder Rückfragen zu deiner Bestellung?",
            notice: "Dann melde dich direkt per Email oder telefonisch (zu unseren Öffnungszeiten) bei uns.",
            email: "kontakt@pottsalat.de",
        },
        tipping: {
            heading: "Digitales Trinkgeld für unser Team?",
            notice: "Egal ob es regnet oder schneit, unsere Fahrer sind für dich im Einsatz. Über Tippie kannst du dich in Form von Online Trinkgeld bei ihnen bedanken. Das Geld geht direkt ohne Abzug ans Team. Klicke einfach auf den Button.",
            text: "Trinkgeld für {{location}}",
        },
    },

    reorder: {
        CTA: "Erneut bestellen",
        stockCheck: {
            title: "Wir schauen, ob noch alle Produkte verfügbar sind...",
            text: "Das kann bis zu zwei Minuten dauern.",
            CTA: "Abbrechen",
        },
        basket: {
            title: "Produkte werden in den Warenkorb gelegt...",
            text: "Das kann bis zu zwei Minuten dauern.",
            CTA: "Abbrechen",
        },
        finished: {
            title: "Wir bringen dich zum Warenkorb...",
            text: "Das dauert nur einen Moment.",
            CTA: "Zum Warenkorb",
        },
        error: {
            title: "Erneute Bestellung nicht möglich",
            text: "Mindestens ein Produkt oder Zutat ist nicht verfügbar.",
            CTA: "Hinweis schließen",
        },
    },

    topbar: {
        label: {
            question: "Wohin möchtest du bestellen?",
            change: "Ändern",
            deliveryTo: "Lieferung nach",
            pickupAt: "Abholung in",
            openingSoon: "Filiale öffnet bald",
            closed: "Filiale geschlossen",
            canPreorder: "Einfach vorbestellen",
            earliest: "Frühstmöglich",
            xxlDelivery: "Einfach vorbestellen für {{day}}",
        },
    },

    home: {
        banner: {
            hero: {
                title: "Frische Salate & Bowls bestellen.",
                title_ramen: "It's Ramen Time, Baby",
                content:
                    "Wir sind Pottsalat der klimafreundliche Lieferservice. Wir liefern gesund & lecker im ausgewählten Zeitfenster zu Dir.",
                content_ramen:
                    "Probiert unsere warmen Bowls im Ramen-Style oder stellt sie euch selbst im neuen Ramen-Konfigurator zusammen.",
                ctaPrimary: "Erstelle deine Bowl",
                ctaPrimary_ramen: "Erstelle deine Ramen",
                ctaSecondary: "Erstelle deinen Salat",
                ctaSecondary_ramen: "Sieh dir unsere Ramen an",
            },
            deliveryOptions: {
                delivery: {
                    title: "Lieferung",
                    content:
                        "Wir liefern im ausgewählten Zeitfenster bis vor die Haustür.",
                },
                pickup: {
                    title: "Abholung",
                    content:
                        "Besuch uns einfach in einer unserer Filialen für die Abholung.",
                },
            },
        },

        aboutUs: {
            title: "Wir sind Pottsalat",
            metaTitle: "Über uns",
            text: "Gestartet sind wir 2017 in einer kleinen Pommesbude. Jetzt wollen wir als erster klimafreundlicher Lieferservice in ganz Deutschland expandieren.",
            buttonText: "Über uns",
        },

        faq: {
            title: "Das werden wir oft gefragt",
            metaTitle: "FAQ",
            text: "Deine Frage taucht hier nicht auf? Wir helfen dir natürlich auch gerne bei anderen Anliegen. Schaue dir unser komplettes FAQ an oder hinterlasse uns einfach eine Nachricht im Livechat.",
            buttonText: "FAQ ansehen",
        },

        usps: {
            title: "Frisch und gesundes Essen bestellen und liefern lassen.",
            metaTitle: "Versprechen",
        },

        categories: {
            title: "Unser Angebot",
            metaTitle: "Kategorien",
        },

        highlights: {
            title: "Neu bei Pottsalat",
            metaTitle: "Highlights",
        },
        promo: {
            header: {
                detail: "Deine persönliche Schüssel voll Glück",
                title: "Erstelle dir jetzt deine Lieblingsbowl",
            },
            content:
                "Stelle dir in unserem Konfigurator deine eigenen Salat- oder Bowlkreationen aus über 80 frischen Zutaten zusammen - ganz individuell nach deinem Geschmack und deiner Ernährungsweise.",
            buttonText: "Jetzt probieren",
        },
    },

    franchise: {
        banner: {
            hero: {
                title: "Starte mit uns die grüne Revolution.",
                content:
                    "Unsere Mission ist es gesunde Ernährung auf einfachem und natürlichem Weg zu ermöglichen. Werde jetzt erfolgreicher Franchise-Partner und starte mit uns durch.",
                cta: "Infomaterial anfordern",
            },
            deliveryOptions: {
                delivery: {
                    title: "Lieferung",
                    content:
                        "Wir liefern im ausgewählten Zeitfenster bis vor die Haustür.",
                },
                pickup: {
                    title: "Abholung",
                    content:
                        "Besuch uns einfach in einer unserer Filialen für die Abholung.",
                },
            },
        },
        franchiseSection: {
            teaser: "Unser Erfolg. Dein Erfolg.",
            heading: "Pottsalat Franchise",
            cardOne: {
                heading: "100%",
                content:
                    "unabhängig von Lieferplattformen wie Lieferando, Wolt, Uber Eats und Co.",
            },
            cardTwo: {
                heading: "500",
                content:
                    "ausgelieferte Salate & Bowls pro Tag an beiden Pilot-Standorten Dortmund und Essen.",
            },
            cardThree: {
                heading: "2.000.000 €",
                content:
                    "durchschnittlicher Jahresumsatz pro Standort an beiden Pilot-Standorten Dortmund und Essen.",
            },
        },
        academy: {
            banner: {
                logo: "Academy",
                topTitle: "Pottsalat Academy",
                title: "Wir sorgen dafür, dass in deiner Filiale alles richtig läuft.",
            },
            partners: {
                title: "Das sagen unsere Partner:innen",
                left: {
                    content:
                        "Als Franchisenehmer der ersten Stunde habe ich mir einen großen Traum erfüllt! Mit Pottsalat zu wachsen und einer gemeinsamen Vision nachzugehen, ist jetzt der nächste Schritt zum Erfolg.",
                    note: "Jonathan Jaspers, Filiale Köln",
                },
                right: {
                    content:
                        "Jetzt mit Pottsalat einen eigenen Standort zu eröffnen und mich selbstständig zu machen, ist der nächste logische Schritt auf meiner Karriereleiter!",
                    note: "Marco Sapienza, Filiale Mainz",
                },
            },
        },
        benefits: {
            topTitle: "Vorteile",
            heading: "Wir unterstützen dich.",
            points: {
                first: "Spannendes Gewinnpotenzial bei relativ geringer Eigenkapitalanforderung",
                second: "Du hast kein langfristiges Mietvertragsrisiko. Wir suchen und mieten den Standort für dich an",
                third: "Der Umbau des Ladenlokals wird von uns für dich realisiert. So kannst du von unserer Erfahrung, wie man einen Lieferdienst aufbaut, profitieren.",
                fourth: "Wir steuern das Marketing für dich, so dass du am Eröffnungstag nicht ohne Kunden da stehst.",
                fifth: "Professionelle Betreuung durch unsere Pottsalat Academy.",
            },
        },
        requirements: {
            heading: "Das solltest du mitbringen",
            points: {
                first: "Freude an Lebensmitteln",
                second: "Sinn für Nachhaltigkeit",
                third: "Unternehmergeist",
                fourth: "Kaufmännisches Verständnis",
                fifth: "Kontaktfreude",
                sixth: "Mind. 50.000 EUR Eigenkapital",
                seventh:
                    "Gastronomische Erfahrung von Vorteil, aber kein Muss!",
            },
        },
        bottomCards: {
            left: {
                title: "Werde jetzt dein eigener Chef!",
                content:
                    "Fordere jetzt weiteres Infomaterial an und starte mit uns durch.",
            },
            right: {
                title: "Unser Weg zum Franchise-System",
                content:
                    "Unser Gründer Ben Küstner erklärt im Podcast-Interview unser Franchise-Konzept.",
                buttonText: "Podcast-Folge anhören",
            },
        },
    },

    category: {
        label: {
            title: "{{categoryName}} bestellen",
            tagline:
                "Alle unsere {{categoryName}} fördern klimafreundliche Landwirtschaft.",
            noItemsFound: {
                title: "Keine passenden Produkte gefunden.",
                defaultContent: "Bitte wähle andere Filter aus.",
                productContent:
                    "Stelle dir {{product}} im Konfigurator zusammen.",
                saladContent: "den verrücktesten Salat",
                bowlContent: "die verrückteste Bowl",
                saladCTA: "Erstelle deinen Salat",
                bowlCTA: "Erstelle deine Bowl",
                subCategoryContent:
                    "Vegetarisch, Glutenfrei, Low Carb?\n{{content}}",
            },
        },
    },
    intoleranceFilters: {
        placeholder: "Unverträglichkeiten",
        clear: "Löschen",
    },
    addressPopup: {
        title: "Wohin möchtest du bestellen?",
        singleOrder: "Einzelbestellung",
        groupOrder: "Gruppenbestellung",
        delivery: "Lieferung",
        pickup: "Abholung",
        save: "Bestätigen",
        zipPlaceholder: "Postleitzahl",
        locPlaceholder: "Straße und Hausnummer",
        warningTitle: "Deine Adresse liegt außerhalb unseres Liefergebiets.",
        warning: "Eventuell liefern wir bald zu dir.",
        notifyMe: "Benachrichtige mich",
        newAddress: "Neue Adresse eingeben",
        pickStore: "Filiale auswählen",
        forcePickupTitle: "Möchtest du stattdessen abholen?",
        noHouseNumberError: "Bitte gib noch eine Hausnummer ein",
        zipcodeWarning: "Bitte gib eine PLZ ein",
        goToPickup: "Ich möchte selbst abholen",
        goToDelivery: "Ich möchte liefern lassen",
        startGroupOrder: "Gruppenbestellung starten",
    },
    createGroupOrder: {
        title: "Gruppenbestellung erstellen 🚀",
        subtitle:
            "Teile deinen Warenkorb über einen Link und bestelle gemeinsam mit Anderen.",
        enterName: "Dein Vorname",
        whereToDeliver: "Wie möchtest du bestellen?",
        pickup: "Abholung",
        delivery: "Lieferung",
        whenToPickup: "Wann möchtest du abholen?",
        whenToDelivery: "Wann sollen wir liefern?",
        pickStoreForPickup: "Wähle eine Pottsalat Filiale aus",
        pickupTextSub:
            "Holt eure Bestellung in unserer Filiale in {{ store }} ab",
        earliestPossible: "Frühstmögliches Zeitfenster",
        orderLatestTo: "Bestelle bis {{ time }}",
        selectDeliverySlot: "Vorbestellen",
        pickTimeslot: "Wähle Datum und Zeitfenster selbst aus.",
        orderAsGroupCTA: "Gruppe erstellen",
        orderTogetherTitle: "Jetzt gemeinsam bestellen! 🥗",
        orderTogetherSubtitle:
            "Teile den folgenden Link, um Gäste einzuladen. Sobald alle ihre Salate & Bowls zu deinem Warenkorb hinzugefügt haben, kannst du die Bestellung abschicken. 🚀",
        orderTogetherDisclaimer:
            "Schließe unsere Webseite erst, wenn du die Gruppenbestellung abgeschlossen hast.",
        linkTitle: "Link teilen",
        linkSubtitle: "Nutze diesen Link, um deinen Warenkorb zu teilen.",
        groupOrderTip: "Jeder, der den Link öffnet, kann Produkte hinzufügen.",
        orderTill:
            "Bis {TIME} Uhr habt ihr Zeit, die Bestellung abzuschließen. ⏰",
        groupOrderWarning:
            "Nur du als Gastgeber kannst die Bestellung bezahlen und abschließen.",
        finish: "Weiter zur Gruppenbestellung",
        qrcode: "Lasse andere den QR-Code scannen, um der Gruppenbestellung beizutreten.",
        linkCopied: "Link kopiert",
        shareLink: "Teile jetzt deinen Warenkorb mit Anderen.",
        pickEarliest: "Wir schlagen dir das frühstmögliche Zeitfenster vor",
    },
    groupCartInfo: {
        title: "Gruppenbestellung",
        shareLink: "Link teilen",
        abort: "Gruppenbestellung löschen",
        edit: "Verwalten",
        abortConfirm: "Wirklich löschen?",
        abortInfo:
            "Damit brichst du die Gruppenbestellung ab und niemand kann mehr daran teilnehmen.",
        successfullyAbortedTitile: "Gruppenbestellung gelöscht.",
        successfullyAbortedDescription:
            "Du hast  die Gruppenbestellung erfolgreich gelöscht.",
    },
    timeslotPopup: {
        title: "Wann holst du die Bestellung ab?",
        titleDelivery: "Wann sollen wir liefern?",
        slotPickTitle: "Abholfenster auswählen",
        deliverySlotTitle: "Lieferfenster auswählen",
        continue: "Weiter",
        finish: "Fertig",
        willBeEarly: "Bist du früher vor Ort?",
        yesEarly: "Ja, ich bin vor Ort. Es kann auch früher geliefert werden.",
        noEarly: "Nein, bitte nicht früher liefern.",
    },
    qrcodePopup: {
        info: "Lasse andere den QR-Code scannen, um der Gruppenbestellung beizutreten.",
        close: "Schließen",
    },
    groupOrderThankYou: {
        bannerText: "Gruppenbestellung von {{name}}",
        title: "Vielen Dank, du bist fertig! 🙌🏼",
        description:
            'Der Gastgeber der Gruppenbestellung führt die Bestellung aus und bezahlt sie. Bitte lasse dieses Fenster geöfffnet, bis die Gruppenbestellung abgeschlossen ist. Nur so hast du die Möglichkeit, die Gruppenbestellung kurzfristig über "Stornieren" zu verlassen.',
        products: "Deine Produkte",
        cancelButton: "Stornieren",
        editButton: "Bestellung ändern",
    },
    memberGroupOrderTimeOut: {
        title: "Du musst schnell sein!",
        description:
            "Du hast nur noch 5 Minuten Zeit, um deine Bestellung abzuschließen. Andernfalls können wir sie nicht für die Gruppenbestellung berücksichtigen.",
        closeBtn: "Alles klar",
    },
    ownerGroupOrderTimeOut: {
        title: "Neues Zeitfenster auswählen!",
        description:
            "Wir haben die Bestellung nicht rechtzeitig erhalten. Um die Gruppenbestellung fortzuführen, wähle ein neues Zeitfenster aus.",
        changeTimeSlotBtn: "Neues Zeitfenster auswählen",
        cancelOrderBtn: "Gruppenbestellung abbrechen",
        tempTitle: "Zu spät!",
        tempDescription: `Wir haben deine Bestellung leider nicht rechtzeitig erhalten.
        Erstelle eine neue Gruppenbestellung, um ein anderes Zeitfenster wählen zu können.`,
        tempCancel: "Schließen",
    },
    configurator: {
        ingredientMainCategories: {
            description: "{{product}} ist inklusive.",
            description_dressing:
                "{{product}} ist inklusive. Das Dressing wird separat verpackt",
            "description_basis-bowl": "Wähle eine Basis-Zutaten für deine Bowl",
            description_basis: "Wähle eine Basis-Zutaten für deinen Salat",
            "description_basis-ramen":
                "Wähle eine Basis-Zutaten für deine Ramen",
            description_plural: "{{product}} sind inklusive.",
            description_dressing_plural:
                "{{product}} sind inklusive. Das Dressing wird separat verpackt",
            "description_basis-bowl_plural":
                "Wähle 1 oder 2 Basis-Zutaten für deine Bowl",
            numbers: {
                1: "ein",
                2: "zwei",
                3: "drei",
                4: "vier",
            },
            basis: {
                title: "Salat Basen",
                name: "eine Salat Basis",
                name_plural: "{{amount}} Salat Basen",
                description: "Eine Basis",
                description_plural: "{{count}} Basen",
            },
            "basis-bowl": {
                title: "Bowl Basen",
                name: "eine Bowl Basis",
                name_plural: "{{amount}} Bowl Basen",
                description: "Eine Basis",
                description_plural: "{{count}} Basen",
            },
            "basis-ramen": {
                title: "Ramen Basen",
                name: "eines Ramen Basis",
                name_plural: "{{amount}} Ramen Basen",
                description: "Eine Basis",
                description_plural: "{{count}} Basen",
            },
            standard: {
                title: "Standards",
                name: "ein Standard",
                name_plural: "{{amount}} Standards",
                description: "Das günstigste Standard",
                description_plural: "Die {{count}} günstigsten Standards",
            },
            extras: {
                title: "Extras",
                name: "ein Extra",
                name_plural: "{{amount}} Extras",
                description: "Das günstigste Extra",
                description_plural: "Die {{count}} günstigsten Extras",
            },
            premium: {
                title: "Premium-Zutaten",
                name: "eine Premium-Zutat",
                name_plural: "{{amount}} Premium-Zutaten",
                description: "Die günstigste Premium Zutat",
                description_plural: "Die {{count}} günstigsten Premiumzutaten",
            },

            topping: {
                title: "Toppings",
                name: "ein Topping",
                name_plural: "{{amount}} Toppings",
                description: "Das günstigste Topping",
                description_plural: "Die {{count}} günstigsten Toppings",
            },
            dressing: {
                title: "Dressings",
                name: "ein Dressings",
                name_plural: "{{amount}} Dressings",
                description: "Ein Dressing",
                description_plural: "{{count}} Dressings",
                name_sauce: "Saucen",
                name_sauce_plural: "",
                description_sauce: "Eine Sauce",
                description_plural_sauce: "{{count}} Saucen",
            },
            sauce: {
                title: "Saucen",
                name: "ein Sauce",
                name_plural: "{{amount}} Saucen",
                description: "Eine Sauce",
                description_plural: "{{count}} Saucen",
            },
        },
        base: {
            bowl: "Bowl",
            salad: "Salat",
            ramen: "Ramen",
        },
        container: {
            bowl: "Bowl",
            salad: "Box",
            ramen: "Bowl",
        },
        maxTotalIngredients: {
            bowl: "Bowl",
            salad: "Salatbox",
            ramen: "Ramenbowl",
        },
        dressings: {
            bowl: "Dressings",
            salad: "Dressings",
            ramen: "Saucen",
        },
        dressing: {
            bowl: "Dressing",
            salad: "Dressing",
            ramen: "Sauce",
        },
        noDressingSelected: {
            bowl: "deiner Bowl",
            salad: "deinem Salat",
            ramen: "deine Ramen",
        },
        addToCartSuccess: {
            bowl: "Deine Lieblingsbowl",
            salad: "Dein Lieblingssalat",
            ramen: "Deine Lieblingsramen",
        },
        instruction: "👉 Wähle zuerst deine Basis, dann weitere Zutaten aus.",
        instruction_plural:
            "👉 Wähle zuerst deine Basen, dann weitere Zutaten aus.",
    },
};

export default translationDe;
